import { expand } from 'uri-template-lite';
import { ISODate } from '../../common/utils';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataInfoType } from '../../input-data/schema/types';
import { InputDataInfoSchema } from '../../input-data/schema/InputDataSchema';
import { DataObjectUrl } from './DataObjectUrl';

export interface DescriptionInputDataInfoRequestParams {
  descriptionId: number;
  valueDate: ISODate;
  dataObjectVersionId?: number;
  subject?: string;
  dataStatus?: 'active' | 'draft';
  submittedDataVersionId?: number;
  sampleId?: number;
}

const queryKey = ['useDescriptionInputDataInfo'] as const;

const getDescriptionInputDataInfo = (
  params?: DescriptionInputDataInfoRequestParams,
) =>
  apiClient
    .get<InputDataInfoType>(expand(DataObjectUrl.INPUT_DATA_INFO, params))
    .then((response) => InputDataInfoSchema.parse(response.data));

export const useDescriptionInputDataInfoQuery = createApiQueryHook(
  queryKey,
  getDescriptionInputDataInfo,
);
